/**
 * Provides resources for Task report macro.
 * The functionality comes from a bundled plugin inline-tasks.
 */

export const taskReportMacroWRM = () => [
	'wr!com.atlassian.confluence.plugins.confluence-inline-tasks:inline-tasks-macro-browser',
];
